// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/common/PrivateRoute';
import Layout from './components/common/Layout';
import Login from './pages/Login';
import AdminDashboard from './components/admin/AdminDashboard';
import Employees from './pages/Employees';
import AddEmployee from './pages/AddEmployee';  // Add this import
import EmployeeDetail from './pages/EmployeeDetail';
import EditEmployee from './pages/EditEmployee';
import Contracts from './pages/Contracts';
import AddContract from './pages/AddContract';
import ContractDetail from './pages/ContractDetail';
import EditContract from './pages/EditContract';
import Postings from './pages/Postings';
import AddPosting from './pages/AddPosting';
import PostingDetail from './pages/PostingDetail';
import SodraReports from './pages/SodraReports';
import Documents from './pages/Documents';
import Reminders from './pages/Reminders';
import EmployeeLogin from './pages/EmployeeLogin';
import EmployeeDashboard from './pages/EmployeeDashboard';
import EmployeeProfile from './pages/EmployeeProfile';
import EmployeeTimesheets from './pages/EmployeeTimesheets';
import EmployeePayslips from './pages/EmployeePayslips';
import EmployeeContracts from './pages/EmployeeContracts';
import EmployeeDocuments from './pages/EmployeeDocuments';
import AdminTimesheets from './pages/AdminTimesheets';
import AdminSalary from './pages/AdminSalary';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <Layout>
                    <AdminDashboard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/employees"
              element={
                <PrivateRoute>
                  <Layout>
                    <Employees />
                  </Layout>
                </PrivateRoute>
              }
            />
	     <Route
              path="/admin/employees/:id"
              element={
                <PrivateRoute>
                  <Layout>
                    <EmployeeDetail />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/employees/new"
              element={
                <PrivateRoute>
                  <Layout>
                    <AddEmployee />
                  </Layout>
                </PrivateRoute>
              }
            />
		<Route
              path="/admin/employees/edit/:id"
              element={
                <PrivateRoute>
                  <Layout>
                    <EditEmployee />
                  </Layout>
                </PrivateRoute>
              }
            />
		<Route
  path="/admin/contracts/new"
  element={
    <PrivateRoute>
      <Layout>
        <AddContract />
      </Layout>
    </PrivateRoute>
  }
/>
		<Route
  path="/admin/contracts/:id"
  element={
    <PrivateRoute>
      <Layout>
        <ContractDetail />
      </Layout>
    </PrivateRoute>
  }
/>

		<Route
  path="/admin/contracts"
  element={
    <PrivateRoute>
      <Layout>
        <Contracts />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/contracts/edit/:id"
  element={
    <PrivateRoute>
      <Layout>
        <EditContract />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/postings"
  element={
    <PrivateRoute>
      <Layout>
        <Postings />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/postings/new"
  element={
    <PrivateRoute>
      <Layout>
        <AddPosting />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/postings/:id"
  element={
    <PrivateRoute>
      <Layout>
        <PostingDetail />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/sodra"
  element={
    <PrivateRoute>
      <Layout>
        <SodraReports />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/documents"
  element={
    <PrivateRoute>
      <Layout>
        <Documents />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/reminders"
  element={
    <PrivateRoute>
      <Layout>
        <Reminders />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/timesheets"
  element={
    <PrivateRoute>
      <AdminTimesheets />
    </PrivateRoute>
  }
/>
<Route
  path="/admin/timesheets"
  element={
    <PrivateRoute>
      <Layout>
        <AdminTimesheets />
      </Layout>
    </PrivateRoute>
  }
/>
<Route
  path="/admin/salary"
  element={
    <PrivateRoute>
      <Layout>
        <AdminSalary />
      </Layout>
    </PrivateRoute>
  }
/>
<Route path="/employee/dashboard" element={<EmployeeDashboard />} />
<Route path="/employee/login" element={<EmployeeLogin />} />
<Route path="/employee/profile" element={<EmployeeProfile />} />
<Route path="/employee/timesheets" element={<EmployeeTimesheets />} />
<Route path="/employee/payslips" element={<EmployeePayslips />} />
<Route path="/employee/documents" element={<EmployeeDocuments />} />
<Route path="/employee/contracts" element={<EmployeeContracts />} />
<Route path="/timesheets" element={<PrivateRoute><AdminTimesheets /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/admin" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
